import type { FC } from 'react';
import { ConditionFormContainer, ConditionFormContainerTitle } from '../RuleEditComponents';
import ConditionForm from './ConditionForm';
import type { FormConditionVariantProps } from '../../types';
import TaskConditionOperator from './TaskConditionOperator';

const ComparisonConditionForm: FC<FormConditionVariantProps> = ({ indexCondition, indexTask, indexVariant }) => {
  const isVariant = typeof indexVariant === 'number';

  return (
    <ConditionFormContainer
      indexCondition={indexCondition}
      title={
        <ConditionFormContainerTitle
          title={`Condition ${indexCondition + 1}`}
          subTitle={`Metric compared to metric`}
          indexCondition={indexCondition}
          indexTask={indexTask}
          showDeleteIcon={!isVariant}
        />
      }
    >
      <ConditionForm
        indexVariant={indexVariant}
        title="1st metric"
        indexCondition={indexCondition}
        indexTask={indexTask}
        field="metric"
      />

      <TaskConditionOperator indexVariant={indexVariant} indexCondition={indexCondition} indexTask={indexTask} />

      <ConditionForm
        indexVariant={indexVariant}
        title="2nd metric"
        indexCondition={indexCondition}
        indexTask={indexTask}
        field="second_metric"
        isSecond
      />
    </ConditionFormContainer>
  );
};

export default ComparisonConditionForm;
